module.exports = __webpack_public_path__ + "img/组 302@2x.354bd236.png";